import BaseEnum from "./base_enum.js";

class SalutationEnumDesc extends BaseEnum {

  name() {
    return "salutation";
  }

  rawValues() {
    return ["herr", "frau", "diverse", "firma"];
  }

}

const SalutationEnum = new SalutationEnumDesc();
export default SalutationEnum;
